// extracted by mini-css-extract-plugin
module.exports = {"footer":"ContactForm_footer__2QDsh","iconContainer":"ContactForm_iconContainer__vKCse","dark":"ContactForm_dark__3Hoq2","copyright":"ContactForm_copyright__ypePL"};